import PropTypes from 'prop-types';
import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import I18nRouter from '~/components/I18nRouter';
import Config from '~/config';
import { urls } from '~/utils';

@withI18next()
class Pagination extends React.PureComponent {
  state = {
    pageValue: this.props.currentPage,
  };

  componentDidUpdate(prevProps) {
    const { currentPage } = this.props;
    if (currentPage !== prevProps.currentPage) {
      this.setState({ pageValue: currentPage });
    }
  }

  handleChangePage = (event) => {
    this.setState({ pageValue: event.target.value });
  };

  handleSubmitPage = (event) => {
    if (event.key && event.key === 'Enter') {
      const { totalPage, path, asPath, query, onChange } = this.props;
      let { pageValue } = this.state;
      pageValue = parseInt(pageValue, 10);
      if (isNaN(pageValue)) return;
      if (pageValue > totalPage || pageValue < 1) return;
      onChange(pageValue);
      const newQuery = { ...query, page: pageValue };
      const queryString = urls.convertToQueryStrings(newQuery);
      I18nRouter.push(
        { pathname: path, query: { ...newQuery, is_tag: true } },
        `${asPath}?${queryString}`,
      );
    }
  };

  onClickNextLink() {
    const { currentPage, totalPage, onChange } = this.props;
    if (currentPage >= totalPage) {
      return {};
    }
    const nextPage = currentPage + 1;
    onChange(nextPage);
  }

  onClickPreviousLink() {
    const { currentPage, onChange } = this.props;
    if (currentPage <= 1) {
      return {};
    }
    const previousPage = currentPage - 1;
    onChange(previousPage);
  }
  onNextLink() {
    const { currentPage, totalPage, query, asPath } = this.props;
    if (currentPage >= totalPage) {
      return {};
    }
    const nextPage = currentPage + 1;
    const newQuery = { ...query, page: nextPage };
    const queryString = urls.convertToQueryStrings(newQuery);
    return {
      as: `${asPath}?${queryString}`,
      query: { ...newQuery, is_tag: true },
    };
  }

  onPreviousLink() {
    const { currentPage, asPath, query } = this.props;
    if (currentPage <= 1) {
      return {};
    }
    const previousPage = currentPage - 1;
    const newQuery = { ...query, page: previousPage };
    const queryString = urls.convertToQueryStrings(newQuery);
    return {
      as: `${asPath}?${queryString}`,
      query: { ...newQuery, is_tag: true },
    };
  }
  render() {
    const {
      totalPage,
      currentPage,
      t,
      path,
      useButtonLink,
      onPrev,
      onNext,
      onChangePage,
    } = this.props;
    const { pageValue } = this.state;

    return (
      <div className="pagination-ac">
        {useButtonLink ? (
          <I18nLink
            href={{ pathname: path, query: this.onPreviousLink().query }}
            as={this.onPreviousLink().as}
          >
            <a
              className={`btn btn-prev-page ${
                +currentPage === 1 ? 'disabled' : ''
              }`}
              onClick={() => this.onClickPreviousLink()}
            >
              <img
                src={`${Config.staticPrefix}/static/assets/svg/leftChevronRight.svg`}
                width={'12'}
                height={'12'}
                alt="icon filter search"
              />
            </a>
          </I18nLink>
        ) : (
          <button
            className={`btn btn-prev-page ${
              +currentPage === 1 ? 'disabled' : ''
            }`}
            disabled={currentPage === 1}
            // onClick={() => onPrev(+currentPage - 1)}
            onClick={() => this.onClickPreviousLink()}
          >
            <img
              src={`${Config.staticPrefix}/static/assets/svg/leftChevronRight.svg`}
              width={'12'}
              height={'12'}
              alt="icon filter search"
            />
          </button>
        )}
        <div className="number-page">
          <input
            type="number"
            pattern="[0-9]*"
            min={1}
            max={totalPage}
            onChange={this.handleChangePage}
            onKeyDown={this.handleSubmitPage}
            value={pageValue}
            className="current-page form-control"
          />
        </div>
        {useButtonLink ? (
          <I18nLink
            href={{ pathname: path, query: this.onNextLink().query }}
            as={this.onNextLink().as}
          >
            <a
              className={`btn btn-next-page ${
                +this.props.currentPage >= this.props.totalPage
                  ? 'disabled'
                  : ''
              }`}
              onClick={() => this.onClickNextLink()}
            >
              <img
                src={`${Config.staticPrefix}/static/assets/svg/rightChevronRight.svg`}
                width={'12'}
                height={'12'}
                alt="icon filter search"
              />
            </a>
          </I18nLink>
        ) : (
          <button
            className={`btn btn-next-page ${
              +this.props.currentPage >= this.props.totalPage ? 'disabled' : ''
            }`}
            disabled={this.props.currentPage >= this.props.totalPage}
            onClick={() => onNext(+currentPage + 1)}
          >
            <img
              src={`${Config.staticPrefix}/static/assets/svg/rightChevronRight.svg`}
              width={'12'}
              height={'12'}
              alt="icon filter search"
            />
          </button>
        )}
        <div className="total-page">
          &nbsp;/&nbsp;
          {totalPage || 1}
        </div>
        <style jsx>
          {`
            .pagination-ac {
              display: inline-flex;
              align-items: center;
            }
            .pagination-ac .title-page {
              min-width: 40px;
              color: #697077;
              margin-left: 8px;
              margin-right: 8px;
            }
            .pagination-ac .btn-prev-page,
            .pagination-ac .btn-next-page {
              border: 1px solid #ececec;
              background: #f8f9fa;
              width: 44px;
              height: 44px;
              color: #509bdc;
              outline: none;
              border-radius: 4px;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
            }

            .pagination-ac .current-page {
              text-align: center;
              padding: 6px 2px;
              border: 2px solid #1b2833;
              box-sizing: border-box;
              border-radius: 4px;
              width: 64px;
              height: 44px;
            }
            .pagination-ac input[type='number'] {
              text-align: center;
              font-weight: 500;
              font-size: 16px;
            }
            .pagination-ac input[type='number']::-webkit-inner-spin-button,
            .pagination-ac input[type='number']::-webkit-outer-spin-button {
              -webkit-appearance: none;
              /*-moz-appearance: none;*/
              appearance: none;
              margin: 0;
            }
            .pagination-ac input[type='number'] {
              -moz-appearance: textfield;
            }
            .pagination-ac .total-page {
              margin-left: 4px;
              white-space: nowrap;
              font-weight: 500;
              font-size: 16px;
              line-height: 28px;
              color: #000000;
            }
            .pagination-ac .number-page {
              color: #697077;
              margin-left: 8px;
              margin-right: 8px;
            }
            .pagination-ac .number-page input {
              border-radius: 4px;
            }
            .pagination-ac .btn-next-page.disabled,
            .pagination-ac .btn-prev-page.disabled {
              pointer-events: none;
            }
            @media (max-width: 599px) {
              .pagination-ac {
              }
            }
          `}
        </style>
      </div>
    );
  }
}

Pagination.defaultProps = {
  currentPage: 1,
  totalPage: 1,
  query: {},
  asPath: '',
  path: '',
  onChange: () => ({}),
  onBlur: () => ({}),
  onNext: () => ({}),
  onPrev: () => ({}),
  useButtonLink: true,
};
Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
  asPath: PropTypes.string,
  path: PropTypes.string,
  query: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  useButtonLink: PropTypes.bool,
};
export default Pagination;
